/**
 * `useComposePort` — resolve the `MessageComposePort` from the ports context,
 * throwing a clear missing-port error when the consumer is mounted without
 * the slot wired.
 *
 * Extracted from the retired inline `ComposeFlow` (where it lived as a
 * private hook) when the US6 wizard (D-120) became a consumer; since T064
 * the wizard is the sole consumer.
 */

import { useContext } from 'react';

import { PortsContext } from '../../providers/PortsContext.js';
import type { MessageComposePort } from './MessageComposePort.js';

export function useComposePort(): MessageComposePort {
  const ports = useContext(PortsContext);
  if (ports === null || ports.messageCompose === undefined) {
    throw new Error(
      'useComposePort: the `messageCompose` port is not provided. Mount the compose surface inside a PortsProvider that wires it.',
    );
  }
  return ports.messageCompose;
}
